import { render, staticRenderFns } from "./IssueDetail.vue?vue&type=template&id=eb09acbc&scoped=true"
import script from "./IssueDetail.vue?vue&type=script&lang=js"
export * from "./IssueDetail.vue?vue&type=script&lang=js"
import style0 from "./IssueDetail.vue?vue&type=style&index=0&id=eb09acbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb09acbc",
  null
  
)

export default component.exports